import { render, staticRenderFns } from "./WebsiteHeaderLifted.vue?vue&type=template&id=34d495aa"
import script from "./WebsiteHeaderLifted.vue?vue&type=script&lang=ts"
export * from "./WebsiteHeaderLifted.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../nuxt-app/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports